import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { BsFolder2 } from 'react-icons/bs';
import { MdOutlineCreateNewFolder } from 'react-icons/md';
import {TbCornerLeftUp} from 'react-icons/tb';
import useConfigsNavigator, { isRoot, getFolderName } from '../../../hooks/useConfigsNavigator';
import { useConfigPathContext } from '../../../providers/ConfigPathContextProvider';
import { isFolder, isMetaData, K_INFO, LoadCycle, useConfigsDataContext } from '../../../providers/ConfigsDataContextProvider';
import { useFolderListenerContext } from '../../../providers/FolderListenerContextProvider';
import CreateSubFolder from './CreateSubFolder';
import FolderCmd from './FolderCmd';
import ConfigFolderCtrl from './ConfigFolderCtrl';
import './FoldersPro.css'

const FoldersPro = () => {
  const {configPath, setConfigPath}             = useConfigPathContext();
  const {getNode, loadCycle}                    = useConfigsDataContext();
  const {goUpFolder}                            = useConfigsNavigator();
  const {folderChanged}                         = useFolderListenerContext();
  const [subFoldersComp, setSubFoldersComp]     = useState('');
  const [reloadFlag, setReloadFlag]             = useState(false);
  const [showCreateFolder, setShowCreateFolder] = useState(false);
  const [folderNameInProgress, setFolderNameInProgress] = useState(null);
  const [folderCreatedError, setFolderCreatedError]     = useState(null);
  
  const refreshMe = useCallback(() => setReloadFlag(prev => !prev), []);

  useEffect(()=>{
      refreshMe();
  },[folderChanged, refreshMe]);


  useEffect(()=>{
    if (loadCycle === LoadCycle.Fetched) {      
      console.log('[FoldersPro] INIT');
      refreshMe();
    }
  }, [loadCycle, refreshMe]);


  const addFolder = useCallback(() => {    
    setShowCreateFolder(true);
  }, []);


  // EFFECT
  //
  useEffect(()=>{    
    const baseFolder = getNode(configPath);

    if (baseFolder) {
      // Decide on "AddFolder" field
      const createErrInfo = baseFolder[K_INFO].folderCreatedErrorInfo;
      const inProgressFolderName = baseFolder[K_INFO].folderNameInProgress;
      setFolderNameInProgress(inProgressFolderName)
      setFolderCreatedError(createErrInfo);
      setShowCreateFolder(Boolean(createErrInfo) || Boolean(inProgressFolderName));
      
      const subFolders = Object.keys(baseFolder)
        .filter(subFolderName => !isMetaData(subFolderName))
        .filter(subFolderName => isFolder(baseFolder[subFolderName]))
        .sort((l,r) => l.toLocaleLowerCase().localeCompare(r.toLocaleLowerCase()))
        .map(subFolderName =>  {
          const renInfo = baseFolder[subFolderName][K_INFO].folderRenamedErrorInfo;
          const renErrInfo = renInfo ? {...renInfo} : null;
          return (
            <div key={subFolderName} className='folderPro'>
              <ConfigFolderCtrl parentFolderPath={configPath} 
                                parentFolder={baseFolder} 
                                folderName={subFolderName}
                                //onRefreshParent={refreshMe}
                                withError={renErrInfo}
                                key={`${subFolderName}_key_`}/>

                    {/* <SubFolder  key={`${subFolderName}_key`}
                                name={subFolderName}
                                // Different for SetupCard and FoldersPro.  TODO: Consider Splitting SubFolder to Setup-Folder and Tree-Folder
                                onClick={() => onSubFolderSelected(subFolderName)}
                                renamemode={baseFolder[subFolderName][K_INFO]?.isRenameMode} 
                                isnew={baseFolder[subFolderName][K_INFO]?.isNew}
                                onRefreshParent={refreshMe}
                          >
                          {subFolderName}
                    </SubFolder> */}
            </div>);
        });

      setSubFoldersComp(subFolders);
    }    
    
  }, [reloadFlag, getNode, configPath, setConfigPath, refreshMe, setSubFoldersComp]);


  // ------  RENDER  ------
  //
  const folderName = useMemo(() => getFolderName(configPath), [configPath]);

  let compTitle;
  let compControl;

  if (isRoot(configPath)) {
    compTitle = <div className='upFolderPane'> <BsFolder2 size='24px'/> <span>Root</span> </div>;
    compControl = <div className='subFoldersControl'>
      <div>&nbsp;</div>
      <FolderCmd onClick={addFolder} tooltip='Create Folder'> <MdOutlineCreateNewFolder size='24px'/></FolderCmd>
    </div>;
  }
  else {
    compTitle = <div className='upFolderPane'> <BsFolder2 size='24px'/> {folderName} </div>;
    compControl = <div className='subFoldersControl'>
      <FolderCmd onClick={goUpFolder} tooltip='Go Up'> <TbCornerLeftUp            size='24px'/>   </FolderCmd>
      <FolderCmd onClick={addFolder} tooltip='Create Folder'>  <MdOutlineCreateNewFolder  size='24px'/>   </FolderCmd>
    </div> 
  }

  return (
    <div className='foldersPro'>
      <div className='folderHeader'>        
        {compTitle}
      </div>

      <div className='subFoldersPane'>
        {/* to add a new button on top of the current folders list controls {ngControl} */}
        {compControl}
        <div className='subFoldersList'>
          {showCreateFolder && <CreateSubFolder parentFolderPath={configPath} hideMe={() => setShowCreateFolder(false)} withError={folderCreatedError} folderNameInProgress={folderNameInProgress}/>}
          {subFoldersComp}
        </div>            
      </div>
    </div>
  )
}

export default React.memo(FoldersPro);